// Prompt 0457 T-5 — Switch binario activo/inactivo compartido a nivel de app.
// Consolida el patron duplicado entre niveles-puesto-panel/NivelModal y
// rol-funcional-panel/tabs/DatosTab (ambos con el mismo markup de ~45L).
//
// Uso:
//   <ActiveSwitch activo={activo} onChange={setActivo} />
//   <ActiveSwitch activo={activo} onChange={setActivo} labelActive="Habilitado" labelInactive="Desactivado" />

import { useI18n } from '../../i18n';

export interface ActiveSwitchProps {
  activo: boolean;
  onChange: (next: boolean) => void;
  labelActive?: string;
  labelInactive?: string;
  disabled?: boolean;
}

export function ActiveSwitch({
  activo,
  onChange,
  labelActive,
  labelInactive,
  disabled = false,
}: ActiveSwitchProps) {
  const { t } = useI18n();
  const adm = ((t.structure as Record<string, unknown>)?.admin as Record<string, unknown>) ?? {};
  const activeLabel = labelActive ?? (adm as Record<string, string>).activo ?? 'Activo';
  const inactiveLabel = labelInactive ?? (adm as Record<string, string>).inactivo ?? 'Inactivo';

  function handleClick() {
    if (disabled) return;
    onChange(!activo);
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={disabled}
      aria-pressed={activo}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        background: 'transparent',
        border: 'none',
        padding: 0,
        cursor: disabled ? 'not-allowed' : 'pointer',
        fontFamily: 'inherit',
        opacity: disabled ? 0.6 : 1,
      }}
    >
      <span
        style={{
          width: 36,
          height: 20,
          borderRadius: 10,
          background: activo ? '#16A34A' : '#D1D5DB',
          position: 'relative',
          transition: 'background 0.15s',
        }}
      >
        <span
          style={{
            position: 'absolute',
            top: 2,
            left: activo ? 18 : 2,
            width: 16,
            height: 16,
            borderRadius: '50%',
            background: '#fff',
            boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
            transition: 'left 0.15s',
          }}
        />
      </span>
      <span style={{ fontSize: 12, fontWeight: 500, color: activo ? '#16A34A' : '#6B7280' }}>
        {activo ? activeLabel : inactiveLabel}
      </span>
    </button>
  );
}
